import { StyleSheet } from 'react-native'

import { color, fontFamily } from '../../../../../theme'

export const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: color.palette.cream,
    alignItems: 'center',
    marginHorizontal: 24,
    borderRadius: 20
  },

  text: {
    fontFamily: fontFamily.GTAmericaExtendedMedium,
    textAlign: 'center'
  },

  container: {
    width: '100%',
    paddingVertical: 24,
    gap: 20
  },
  titleStyle: {
    fontFamily: fontFamily.GTAmericaStandardMedium,
    fontSize: 20,
    textAlign: 'center',
    paddingHorizontal: 10
  },

  buttonTitleStyle: {
    fontFamily: fontFamily.GTAmericaStandardMedium,
    fontSize: 16,
    paddingVertical: 5
  }
})
